module.exports = __webpack_public_path__ + "img/featuredartist (2).f3d97125.jpg";